import React, { forwardRef, useEffect } from "react";
import { Form } from "react-bootstrap";

const StatusInput = forwardRef<HTMLInputElement, {tabIndex: number}>(
    ({ tabIndex, ...props }, ref) => {
    
    useEffect(() => {
        if (ref && 'current' in ref && ref.current && ref.current.value && ref.current.value === 'active') {
            ref.current.checked = true;
            ref.current.value = ref.current.checked ? 'active' : 'inactive';
        }        
    }, [ref]);

    return (
        <Form.Group className="form-group template-status required">
            <Form.Label className="form=label" htmlFor="mailing-status-checkbox">Statut</Form.Label>
            <div className="form-switch status">
                <Form.Control type="checkbox" className="form-switch-checkbox" id="template-status-checkbox" tabIndex={4} ref={ref}/>
                <Form.Label className="form-switch-label" htmlFor="template-status-checkbox">
                    <span className="icon"></span>
                    <span className="text">
                        <span className="on">Actif</span>
                        <span className="off">Inactif</span>
                    </span>
                </Form.Label>
            </div>
        </Form.Group>
    );
});

export default StatusInput;